import * as ActionTypes from '../addPhotos';

const initialState = null;

const projectsReducers = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_PROJECTS:
      return action.projects;
    case ActionTypes.UPDATE_PROJECT_TITLE:
      let foundIndex = state.findIndex((x) => x.projectID == action.projectPK);
      if (foundIndex !== -1) {
        state[foundIndex].projectTitle = action.name;
        state[foundIndex].projectAuthor = action.author;
      }
      return state;
    case ActionTypes.DELETE_PROJECT:
      let newState = state;
      foundIndex = newState.findIndex((x) => x.projectID == action.projectPK);
      if (foundIndex !== -1) newState = newState.toSpliced(foundIndex, 1);
      return newState;
    default:
      return state;
  }
};

export default projectsReducers;
